/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
  IPublicClientApplication,
  InteractionRequiredAuthError,
} from '@azure/msal-browser'
import { msalConfig } from 'lib/msalConfig'

const instance = new PublicClientApplication(msalConfig)

instance.addEventCallback((event: EventMessage) => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS &&
    (event.payload as AuthenticationResult)?.account
  ) {
    const { account } = event.payload as AuthenticationResult
    instance.setActiveAccount(account)
  }
})

// make requests with azure headers
const getMsalAuthToken = async () => {
  const activeAccount = instance.getActiveAccount()
  const accounts = instance.getAllAccounts()
  const request = {
    authority: window.appConfig.AD_AUTHORITY,
    scopes: [window.appConfig.AD_SCOPE],
    account: activeAccount || accounts[0],
  }

  if (activeAccount && accounts) {
    if (window.Cypress) {
      const storageToken = localStorage.getItem('accessToken')

      return storageToken ? JSON.parse(storageToken) : ''
    }

    const authResult = await instance
      .acquireTokenSilent(request)
      .catch((error) => {
        if (error instanceof InteractionRequiredAuthError) {
          return instance.logoutPopup().catch((error) => {
            // eslint-disable-next-line no-console
            console.error(error)
          })
        }
        throw error
      })

    const token = authResult && authResult.accessToken

    return token
  }
  return ''
}

const getUserRoles = (msalInstance: IPublicClientApplication) => {
  const account = msalInstance.getAllAccounts()
  if (account) {
    // @ts-ignore
    if (account[0]?.idTokenClaims?.permissions) {
      // @ts-ignore
      return account[0].idTokenClaims.permissions.split(',')
    }
  }

  return []
}

const getUserStores = (msalInstance: IPublicClientApplication) => {
  const account = msalInstance.getAllAccounts()
  if (account) {
    // @ts-ignore
    if (account[0]?.idTokenClaims?.contexts) {
      // @ts-ignore
      return account[0].idTokenClaims.contexts.split(',')
    }
  }

  return []
}

export {
  instance as msalInstance,
  getUserRoles,
  getMsalAuthToken,
  getUserStores,
}
